import {
  SHOW_CONTACT_POPUP,
  HIDE_CONTACT_POPUP, START, SUCCESS, SEND_CONTACT_POPUP
} from "../constants";

const initialState = {
  isShowContactPopup: false,
  errorsFields: null,
  success: false
};

export default (state = initialState, action) => {
  const {type, response} = action;

  switch (type) {
    case SHOW_CONTACT_POPUP:
      return { ...state, isShowContactPopup: true };

    case HIDE_CONTACT_POPUP:
      return { ...state, isShowContactPopup: false, errorsFields: null, success: false };

    case SEND_CONTACT_POPUP + START:
      return { ...state, errorsFields: null, success: false };

    case SEND_CONTACT_POPUP + SUCCESS:
      return { ...state, errorsFields: response.length ? response : null, success: response.success };

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/contactus.js